import { useContext } from 'react';
import { AppReadyStateContext } from '@/containers/AppReadyState/Context';

export const useAppReadyState = () => {
  return useContext(AppReadyStateContext);
};